import { IconCreditCard } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { Installments as InstallmentsType } from 'typings'
import { useDrawerState, useFormStateContext } from '../../../..'
import { useConditions } from '../useConditions'
import { Editor } from './Editor'
import { InstallmentsView } from './View'
import { messages } from './messages'

interface Props {
  name: string
}

export type InstallmentsConfig =
  | InstallmentsType
  | {
      min: undefined
      max: undefined
    }

export function Installments(props: Props) {
  const { name } = props
  const { formatMessage: i18n } = useIntl()

  const { form } = useFormStateContext()
  const config: InstallmentsConfig = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: i18n(messages.title),
    icon: <IconCreditCard />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: InstallmentsConfig | undefined) =>
    form.setValue(name, values)

  return (
    <>
      <InstallmentsView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <Editor state={editorState} initialConfig={config} onSave={handleSave} />
    </>
  )
}
